module.exports = __webpack_public_path__ + "img/16_harding.a2d3d7f5.jpg";